/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IEtapas from 'Infotrack@Modelos/smartStock/etapas/entidades/etapas';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorIndicadorCargaGlobal,
    manejadorDialogoGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import EtapasCM from '../controladorModelo/etapasCM';
import { acciones, IEstadoEtapas } from '../reductorEtapas';
import EtapasVista from '../vista/tablaEtapasVista';
import Texto from '@infotrack/presentacion-componentes/texto';
import { useSelector } from 'react-redux';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';

const etapasCM = new EtapasCM();

const TableEtapasCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [etapass, setEtapass] = React.useState<IEtapas[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoEtapas>();
    const idEmpresa = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.usuarioInformacion!.IdEmpresa);

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarEtapas();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarEtapas = () => {
        manejadorIndicadorCargaGlobal(true);
        etapasCM.ConsultarListaEtapasPorFiltro(idEmpresa).then((etapass) => {
            setEtapass(etapass);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadEtapas?: IEtapas) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadEtapas, tipoFormulario } });
    };

    const confirmarEliminacion = (etapas: IEtapas) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarEtapas(etapas),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarEtapas = (etapas: IEtapas) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        etapasCM.eliminarEtapas(etapas).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <EtapasVista
            etapass={etapass}
            cargarEtapas={cargarEtapas}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableEtapasCV;
